// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/ghana-ticker-tape/ghana-ticker-tape.component.scss
// module id = 767
// module chunks = 0